<template>
  <section class="section section--alt">
    <div class="container">
      <h2 class="section-title fade-in-up">並ばない。待たない。お財布いらず。</h2>
      <div class="row mt-5">
        <!-- スマホから簡単注文 -->
        <div class="col-md-4 text-center feature-col fade-in-up delay-1">
          <div class="feature-icon-wrap">
            <i class="bi bi-phone feature-icon"></i>
          </div>
          <h3 class="feature-title">スマホから簡単注文</h3>
          <p class="feature-desc">朝の隙間時間にサクッと予約完了。</p>
        </div>
        <!-- 決済はスマホで完結 -->
        <div class="col-md-4 text-center feature-col fade-in-up delay-2">
          <div class="feature-icon-wrap">
            <i class="bi bi-credit-card feature-icon"></i>
          </div>
          <h3 class="feature-title">決済はスマホで完結</h3>
          <p class="feature-desc">お財布いらずで管理もラクラク。</p>
        </div>
        <!-- 学校まで配送 -->
        <div class="col-md-4 text-center feature-col fade-in-up delay-3">
          <div class="feature-icon-wrap">
            <i class="bi bi-geo-alt feature-icon"></i>
          </div>
          <h3 class="feature-title">学校まで配送</h3>
          <p class="feature-desc">指定場所でピックアップするだけ。</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionFeatures',
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables';
@import '@/assets/scss/mixins';

.feature-col {
  margin-bottom: 2rem;
}

.feature-icon-wrap {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: rgba($color-primary, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.25rem;
  transition: transform 0.3s ease, background-color 0.3s ease;

  &:hover {
    transform: scale(1.1);
    background-color: rgba($color-primary, 0.15);
  }
}

.feature-icon {
  font-size: 2rem;
  color: $color-primary;
}

.feature-title {
  font-size: $font-size-section-subtitle;
  font-weight: 700;
  color: $color-text;
  margin-bottom: 0.75rem;
}

.feature-desc {
  font-size: $font-size-body;
  color: $color-text-light;
  line-height: 1.8;
}
</style>
